import { type IAdEvent } from '@sxmp/ad-sdk-web';

import { type IActionOf } from '../../../../types';
import { Actions } from '../constants';
import { type IRelayAdManagerPayload } from '../types';

export function relayAdManagerEvent(
  event: IAdEvent,
): IActionOf<Actions.AD_MANAGER_EVENT, IRelayAdManagerPayload> {
  return {
    type: Actions.AD_MANAGER_EVENT,
    data: { event },
  };
}
